import Action from "../actions"

export function leftMenuReducer(state = {firstLevel: 'dashboard', secondLevel: 'default', title: 'Dashboard', firstTitle: 'Dashboard', secondTitle: 'Dashboard'}, action) {
    if (action.type === Action.SET_LEFT_MENU) {
        return action.data
    }
    return state;
}
